export const standardLearnosityConfig = {
  questions_api_init_options: {
    show_distractor_rationale: {
      per_question: "always",
      per_response: "always",
    },
  },
  configuration: {
    onsubmit_redirect_url: false,
    idle_timeout: false,
    submit_criteria: {
      type: "attempted",
      threshold: 100,
    },
  },
  navigation: {
    auto_save: {
      save_interval_duration: 30,
      ui: true,
    },
    show_intro: false,
    show_outro: false,
    scrolling_indicator: true,
    warning_on_change: false,
    skip_submit_confirmation: true,
  },
  regions: {
    "top-left": [],
    "top-right": [],
    right: [],
    "bottom-right": [
      { type: "next_button" },
      { type: "horizontaltoc_element" },
      { type: "previous_button" },
    ],
    items: [
      { type: "progress_element" },
      { type: "slider_element", scrollable_option: false },
    ],
    "bottom-left": [{ type: "accessibility_button" }],
    bottom: [],
  },
  title: "All About Interviews",
  labelBundle: {
    confirm: "Okay",
    continue: "Okay",
    accessibility: "",
    warningOnChangeHeadingMsg: "Hang on!",
    warningOnChangeBodyMsg: "Complete all questions before you continue.",
    warningOnChangeCancelButton: "Go Back",
    warningOnChangeContinueButton: "Continue Anyway",
    submitButtonLabel: "Done",
    submitCriteriaNotMet: "You skipped at least one question",
    submitTest: "You missed something...",
    submitCriteriaLessThanRequiredAttemptedQuestionsWarning:
      "Go back and answer {{numberOfMoreQuestionsNeeded}} question(s) to complete the Ladder.",
  },
};

export const gameLearnosityConfig = {
  ...standardLearnosityConfig,
  regions: {
    "top-left": [],
    "top-right": [],
    right: [],
    "bottom-right": [{ type: "next_button" }],
    items: [{ type: "slider_element", scrollable_option: false }],
    "bottom-left": [],
    bottom: [],
  },
  labelBundle: {
    confirm: "Okay",
    continue: "Okay",
    accessibility: " ",
    warningOnChangeHeadingMsg: "Hang on!",
    warningOnChangeBodyMsg: "Complete all questions before you continue.",
    warningOnChangeCancelButton: "Go Back",
    warningOnChangeContinueButton: "Continue Anyway",
    nextButtonLabel: " ",
    submitButtonLabel: "Done",
    submitCriteriaNotMet: "You must complete the game to complete the Ladder.",
    submitTest: "You missed something...",
    submitCriteriaLessThanRequiredAttemptedQuestionsWarning: "",
  },
};

export const profilerLearnosityConfig = {
  ...standardLearnosityConfig,
  regions: {
    "top-left": [],
    "top-right": [],
    right: [],
    "bottom-right": [{ type: "next_button" }, { type: "previous_button" }],
    items: [
      { type: "progress_element" },
      { type: "slider_element", scrollable_option: false },
    ],
    "bottom-left": [{ type: "accessibility_button" }],
    bottom: [],
  },
  labelBundle: {
    confirm: "Okay",
    continue: "Okay",
    accessibility: " ",
    warningOnChangeHeadingMsg: "Hang on!",
    warningOnChangeBodyMsg: "Complete all questions before you continue.",
    warningOnChangeCancelButton: "Go Back",
    warningOnChangeContinueButton: "Continue Anyway",
    nextButtonLabel: " ",
    submitButtonLabel: "Done",
    submitCriteriaNotMet: "You skipped at least one question",
    submitTest: "You missed something...",
    submitCriteriaLessThanRequiredAttemptedQuestionsWarning:
      "Go back and answer {{numberOfMoreQuestionsNeeded}} more questions to complete the ladder.",
  },
};

// Minimal config that lets Learnosity activity defaults take precedence
export const genericLearnosityConfig = {
  configuration: {
    onsubmit_redirect_url: false,
  },
  navigation: {
    auto_save: {
      save_interval_duration: 30,
      ui: true,
    },
    skip_submit_confirmation: true,
  },
};

export const quizLearnosityConfig = {
  ignore_question_attributes: ["instant_feedback"],
  configuration: {
    onsubmit_redirect_url: false,
    idle_timeout: false,
  },
  navigation: {
    show_outro: false,
    warning_on_change: false,
    skip_submit_confirmation: true,
  },
  regions: "main",
  region_overrides: {
    right: false,
    "bottom-right": false,
    "top-left": false,
    "top-right": false,
  },
};

export const learnLearnosityConfig = {
  ignore_question_attributes: ["instant_feedback"],
  configuration: {
    onsubmit_redirect_url: false,
    idle_timeout: false,
  },
  navigation: {
    auto_save: {
      save_interval_duration: 30,
      ui: false,
    },
    show_intro: false,
    show_outro: false,
    warning_on_change: false,
    skip_submit_confirmation: true,
  },
  regions: "main",
  region_overrides: {
    right: false,
    "bottom-right": false,
    "top-left": false,
    "top-right": false,
  },
};

export const trackerLearnosityConfig = {
  questions_api_init_options: {
    show_distractor_rationale: {
      per_question: "always",
      per_response: "always",
    },
  },
  configuration: {
    onsubmit_redirect_url: false,
    idle_timeout: false,
    submit_criteria: {
      type: "attempted",
      threshold: 100,
    },
  },
  navigation: {
    auto_save: {
      save_interval_duration: 30,
      ui: true,
    },
    show_intro: false,
    show_outro: false,
    scrolling_indicator: true,
    warning_on_change: false,
    skip_submit_confirmation: true,
  },
  regions: {
    "top-left": [],
    "top-right": [],
    right: [],
    "bottom-right": [
      { type: "next_button" },
      { type: "horizontaltoc_element" },
      { type: "previous_button" },
    ],
    items: [
      { type: "progress_element" },
      { type: "slider_element", scrollable_option: false },
    ],
    "bottom-left": [{ type: "accessibility_button" }],
    bottom: [],
  },
  title: "All About Interviews",
  labelBundle: {
    confirm: "Okay",
    continue: "Okay",
    accessibility: "",
    warningOnChangeHeadingMsg: "Hang on!",
    warningOnChangeBodyMsg: "Complete all questions before you continue.",
    warningOnChangeCancelButton: "Go Back",
    warningOnChangeContinueButton: "Continue Anyway",
    submitButtonLabel: "Save",
    submitCriteriaNotMet:
      "Come back later to complete your hours for this week",
    submitTest: "Progress Saved",
    submitCriteriaLessThanRequiredAttemptedQuestionsWarning:
      "Click exit above.",
  },
};
